export default "__VITE_ASSET__DyLlmN50__"